
/**
 * Block Video Carousel.
 */


/* eslint-disable class-methods-use-this */
import $ from 'jquery';

function swapNums() {
	$('a.movement-swap-number').each(function () {
		$(this).attr('href', 'tel:+13103629019');
		$(this).html('310-362-9019');
	});

	$('li.movement-swap-number > a').each(function () {
		$(this).attr('href', 'tel:+13103629019');
		$(this).html('310-362-9019');
	});
}

if (window.location.pathname === '/movement-disorders/a-new-alternative-for-parkinsons-disease-treatment/') {
	swapNums();
}
